<template>
	<PopUp
		:title="title"
		size="lg"
		hide-close
		hide-actions
	>
		<div class="characteristic-completion-check">
			<div class="characteristic-completion-check--content">
				<div>
					<Jon/>
				</div>
				<slot name="info"/>
			</div>
			<div class="characteristic-completion-check--actions">
				<Button
					:text="okButtonText"
					secondary
					class="mr-2"
					@click="$emit('ok')"
				/>
				<Button
					text="Jetzt eingeben"
					icon="pencil"
					@click="$emit('abort')"
				/>
			</div>
			<div class="characteristic-completion-check--cancel">
				<a href="#" @click.prevent="$emit('skip')">Später eingeben</a>
			</div>
		</div>
	</PopUp>
</template>

<script>
import PopUp from "@/vue/common/PopUp.vue";
import Jon from "@/vue/common/image/Jon.vue";
import Button from "@/vue/common/Button.vue";

export default {
	components: {Button, Jon, PopUp},

	props: {
		title: {
			type: String,
			required: true,
		},
		okButtonText: {
			type: String,
			required: true,
		},
	}
}
</script>
